/* global Materialize confirm */
import angular from 'angular'

/* @ngInject */
const toaster = (
  settingData,
  authService,
  ngDialog,
) => {
  const self = {}
  self.counter = 1

  self.confirm = (_message) => {
    return confirm(_message)
  }

  self.toast = (_message, _color = 'green', _force = false) => {
    if (_color !== 'green' && _color !== 'red' && _color !== 'orange') {
      _color = 'green'
    }
    if (!authService.isLog() && !_force) {
      return
    }

    const id = 'toast-btn' + self.counter++
    const html = '<span>' + _message + '</span><button id="' + id + '" class="btn-flat toast-btn grey-text lighten-2"><i class="material-icons">close</i></button>'
    const classes = 'rounded ' + _color + '-text'
    let timer
    if (authService.isLog()) {
      timer = settingData.general.sliders.toastTimer.model * 1000
    } else {
      timer = 5000
    }
    if (timer === 0) {
      return
    } else if (timer < 0) {
      timer = undefined
    }

    Materialize.toast(
      html,
      timer,
      classes
    )

    const toastButton = angular.element('#' + id)

    toastButton.bind('click', (event) => {
      const toastElement = toastButton.parent()
      toastElement.css('display', 'none')
    })
  }

  self.message = (_message, _color = 'green') => {
    self.toast(_message, _color)
  }

  self.warning = (_message) => {
    self.toast(_message, 'orange')
  }

  self.error = (_message, _force = false) => {
    console.error(_message)
    self.toast(_message, 'red', _force)
  }

  return self
}

export default toaster



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/utils/toaster.js